import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { formatCurrency2D, formatToDdMmYySlash, formatDateSlash } from '@/services/utils/global';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}

const wasaBillPrinter = () => {

    const thinLine = () => ({
        canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 0.3 }],
        margin: [0, 4, 0, 4]
    });

    const buildCopy = (company, invoice, copyLabel, userName) => {
        const items = invoice.has_item_detail ? invoice.general : invoice.ledgers;

        const itemRows = items.map(item => [
            { text: invoice.has_item_detail ? item.product.name : item.head.name, fontSize: 8 },
            { text: invoice.has_item_detail ? formatCurrency2D(item.quantity) : '', alignment: 'right', fontSize: 8 },
            { text: formatCurrency2D(item.amount), alignment: 'right', fontSize: 8 }
        ]);

        return {
            stack: [
                {
                    columns: [
                        {
                            width: 70,
                            stack: [
                                company.logo64
                                    ? { image: company.logo64, maxHeight: 55, maxWidth: 65 }
                                    : { text: '' }
                            ]
                        },
                        {
                            width: '*',
                            alignment: 'center',
                            stack: [
                                company.name ? { text: company.name, bold: true, fontSize: 12 } : '',
                                company.address ? { text: company.address, fontSize: 8 } : '',
                                company.phone ? { text: 'Phone: ' + company.phone, fontSize: 8 } : '',
                                company.email ? { text: company.email, fontSize: 8 } : '',
                            ]
                        },
                        {
                            width: 90,
                            stack: [
                                {
                                    table: {
                                        widths: ['*'],
                                        body: [[{ text: copyLabel, bold: true, fontSize: 8, alignment: 'center', margin: [2, 3, 2, 3] }]]
                                    },
                                    layout: { hLineWidth: () => 0.5, vLineWidth: () => 0.5 }
                                }
                            ]
                        }
                    ],
                    columnGap: 5,
                    margin: [0, 0, 0, 0]
                },

                thinLine(),

                {
                    columns: [
                        {
                            width: '55%',
                            stack: [
                                { text: [{ text: 'NAME : ', bold: true }, invoice.contact ? invoice.contact.name : ''], fontSize: 8 },
                                { text: [{ text: 'ADDRESS : ', bold: true }, invoice.contact ? (invoice.contact.full_address || invoice.contact.address || '') : ''], fontSize: 8 },
                            ]
                        },
                        {
                            width: '45%',
                            alignment: 'right',
                            stack: [
                                { text: [{ text: 'BILL NO : ', bold: true }, invoice.bill_number || ''], fontSize: 8 },
                                { text: [{ text: 'ISSUE DATE : ', bold: true }, formatToDdMmYySlash(invoice.date)], fontSize: 8 },
                                invoice.due_date
                                    ? { text: [{ text: 'DUE DATE OF PAYMENT : ', bold: true }, formatToDdMmYySlash(invoice.due_date)], fontSize: 8 }
                                    : '',
                            ]
                        }
                    ],
                    margin: [0, 0, 0, 4]
                },

                itemRows.length > 0 ? {
                    table: {
                        widths: ['*', 'auto', 'auto'],
                        body: itemRows
                    },
                    layout: {
                        hLineWidth: (i, node) => (i === 0 || i === node.table.body.length) ? 0.3 : 0,
                        vLineWidth: () => 0,
                        paddingTop: () => 2,
                        paddingBottom: () => 2,
                    },
                    margin: [0, 0, 0, 5]
                } : '',

                {
                    columns: [
                        {
                            width: '55%',
                            stack: []
                        },
                        {
                            width: '45%',
                            alignment: 'right',
                            stack: [
                                invoice.subtotal_amount
                                    ? { text: [{ text: 'AMOUNT: ', bold: true }, formatCurrency2D(invoice.subtotal_amount)], fontSize: 8 }
                                    : '',
                                invoice.vat_amount
                                    ? { text: [{ text: 'VAT: ', bold: true }, formatCurrency2D(invoice.vat_amount)], fontSize: 8 }
                                    : '',
                                invoice.round_up_discount
                                    ? { text: [{ text: 'DISCOUNT: ', bold: true }, formatCurrency2D(invoice.round_up_discount)], fontSize: 8 }
                                    : '',
                                { text: [{ text: 'NET PAYABLE: ', bold: true }, formatCurrency2D(invoice.total_amount)], fontSize: 8 },
                            ]
                        }
                    ],
                    margin: [0, 0, 0, 5]
                },

                thinLine(),

                {
                    columns: [
                        {
                            width: '28%',
                            stack: []
                        },
                        {
                            width: '42%',
                            text: 'NB: Automatically generated bill does not require signature.',
                            fontSize: 7,
                            italics: true,
                            margin: [0, 2, 0, 0]
                        },
                        { width: '*', text: 'Seal', alignment: 'center', fontSize: 8, margin: [0, 2, 0, 0] },
                        { width: 'auto', text: 'Officer', alignment: 'right', fontSize: 8, margin: [0, 2, 0, 0] }
                    ],
                    margin: [0, 0, 0, 4]
                },

                {
                    text: 'Printed by: ' + (userName || '') + '  ' + formatDateSlash(new Date()),
                    fontSize: 7,
                    alignment: 'right'
                }
            ]
        };
    }

    const exportToPDFWasaBill = (company, invoice, userName) => {
        const doc = {
            pageSize: 'A4',
            pageMargins: [40, 25, 40, 25],
            content: [
                buildCopy(company, invoice, 'OFFICE COPY', userName),
                {
                    canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1, dash: { length: 4 } }],
                    margin: [0, 10, 0, 10]
                },
                buildCopy(company, invoice, 'CONSUMER COPY', userName),
            ],
            defaultStyle: {
                color: 'black',
                fontSize: 8,
                font: 'SulaimanLipi'
            },
            info: { title: invoice.bill_number }
        };

        pdfMake.createPdf(doc).open();
    }

    return {
        exportToPDFWasaBill
    }
}

export default wasaBillPrinter;
